import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2022;

export const defaultState = {
  jea2022: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2022_SET_LIST(state, list) {
    state.jea2022.list = list;
  },
  JEA2022_SET_LIST_LOADING(state, isLoading) {
    state.jea2022.listLoading = isLoading;
  },
};

export const getters = {
  getJea2022List: state => state.jea2022.list,
  getJea2022ListIsLoading: state => state.jea2022.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2022Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2022Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2022List({ commit }, filterByStatus) {
    commit('JEA2022_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2022_SET_LIST_LOADING', false);
          commit('JEA2022_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2022_SET_LIST_LOADING', false);
        commit('JEA2022_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2022All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2022List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2022DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2022 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2022;



// WEBPACK FOOTER //
// ./src/store/payout/jea2022.js